import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, vShow as _vShow, withDirectives as _withDirectives, Teleport as _Teleport, createBlock as _createBlock } from "vue"

import {ref, onMounted, onUnmounted} from 'vue'



export default /*@__PURE__*/_defineComponent({
  __name: 'BackToTopButton',
  setup(__props) {

const showButton = ref(false)

const handleScroll = () => {
  showButton.value = window.scrollY > 500
}

const scrollToTop = () => {
  window.scrollTo({
    top: 0
  })
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _withDirectives(_createElementVNode("button", {
      onClick: scrollToTop,
      class: "scroll-to-top__button q-shadow-sm"
    }, _cache[0] || (_cache[0] = [
      _createElementVNode("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        _createElementVNode("path", {
          d: "M8 4L16 12L8 20",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        })
      ], -1)
    ]), 512), [
      [_vShow, showButton.value]
    ])
  ]))
}
}

})